import { SEO } from "@/components/SEO";

export default function Terms() {
  return (
    <div className="flex flex-col w-full">
      <SEO 
        title="Terms of Service" 
        description="Our rules for working together. Read the AccelerateByte Terms of Service."
        noindex={true}
      />
      <section className="pt-32 pb-12 px-4 border-b border-border/50">
        <div className="container mx-auto max-w-3xl">
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
          <p className="text-muted-foreground">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-16 px-4 container mx-auto max-w-3xl">
        <div className="prose prose-invert prose-lg max-w-none">
          <p>Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the acceleratebyte.com website operated by AccelerateByte.</p>
          
          <h2 className="font-display">1. Acceptance of Terms</h2>
          <p>By accessing or using our services, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the service.</p>

          <h2 className="font-display">2. Service Provision</h2>
          <p>AccelerateByte provides software development, consulting, and related technical services. The specific scope, deliverables, timelines, and compensation for any project will be outlined in a separate Statement of Work (SOW) or Master Services Agreement (MSA) signed by both parties.</p>

          <h2 className="font-display">3. Intellectual Property</h2>
          <p>Unless otherwise agreed upon in writing within a specific SOW, all code, designs, architectures, and documentation produced during an engagement remain the intellectual property of AccelerateByte until full payment is received. Upon full payment, intellectual property rights transfer to the client as stipulated in the MSA.</p>

          <h2 className="font-display">4. Confidentiality</h2>
          <p>We respect the confidential nature of your business. Both parties agree to hold in strict confidence any proprietary information exchanged during the course of business, subject to a formal Non-Disclosure Agreement (NDA) if executed.</p>

          <h2 className="font-display">5. Limitation of Liability</h2>
          <p>In no event shall AccelerateByte, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.</p>

          <h2 className="font-display">6. Governing Law</h2>
          <p>These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions.</p>
          
          <h2 className="font-display">Contact Us</h2>
          <p>If you have any questions about these Terms, please contact us at hello@acceleratebyte.com.</p>
        </div>
      </section>
    </div>
  );
}
